import { WidgetProps } from '@rjsf/utils';
import { Input } from '@amzn/awsui-components-react-v3';
import * as React from 'react';
import { getValueFromContext, OmniDUAContext } from 'src/components/datausageagreement/widgets/OmniDUAContext';

export interface ConditionallyDisabledInputProps extends WidgetProps {
  omniContext: OmniDUAContext;
}

export function ConditionallyDisabledInput(props: ConditionallyDisabledInputProps) {
  const contextField = props.schema.omniContextField;

  let valueOverwrite: string;
  if (!!contextField) {
    valueOverwrite = getValueFromContext(props.omniContext, contextField);
  }

  const isOverwritten = !!valueOverwrite;
  const inputValue = isOverwritten ? valueOverwrite : props.value;

  if (isOverwritten) {
    props.onChange(valueOverwrite);
  }

  return (
    <Input
      disabled={isOverwritten || props.readonly}
      readOnly={isOverwritten || props.readonly}
      onChange={(event) => {
        if (!isOverwritten) {
          props.onChange(event.detail.value);
        }
      }}
      value={inputValue}
    />
  );
}
